import React from 'react';
import ReactDOM from 'react-dom'; // <-- Changed: No longer '/client'
import App from './App';
import './styles/tailwind.css'; // Note: This might be './index.css' depending on your template

// Changed: Using the older ReactDOM.render method instead of createRoot
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
